import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const HandoverRedirect = () => {
  const { handoverId } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Store the handover ID in session storage
    if (handoverId) {
      sessionStorage.setItem('viewHandoverId', handoverId);
    }
    
    // Redirect to employee dashboard
    navigate('/employee/dashboard');
  }, [handoverId, navigate]);
  
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-900"></div>
    </div>
  );
};

export default HandoverRedirect;
